import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type Props = {
  open: boolean;
  statusLabel: string;
  statusKey?: "completed" | "no_show" | "cancelled" | "";
  description?: string;
  onClose: () => void;
  onConfirm: () => void;
  confirmLoading?: boolean;
};

const StatusChangeConfirmDialog = ({
  open,
  statusLabel,
  statusKey = "",
  description,
  onClose,
  onConfirm,
  confirmLoading = false,
}: Props) => {
  const getMessage = () => {
    switch (statusKey) {
      case "completed":
        return "Are you sure you want to mark this appointment as completed?";
      case "no_show":
        return "Are you sure you want to mark this appointment as a no-show?";
      case "cancelled":
        return "Are you sure you want to cancel this appointment?";
      default:
        return `Are you sure you want to ${statusLabel.toLowerCase()} this appointment?`;
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>{`Confirm ${statusLabel}`}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description || getMessage()}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={confirmLoading} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={confirmLoading}
        >
          {confirmLoading ? "Processing..." : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusChangeConfirmDialog;
